module.exports = __webpack_public_path__ + "img/attack_helldoor.c3888835.png";